import { render } from "./edit.vue?vue&type=template&id=c082a41a&scoped=true"
import script from "./edit.vue?vue&type=script&lang=ts"
export * from "./edit.vue?vue&type=script&lang=ts"

import "./edit.vue?vue&type=style&index=0&id=c082a41a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c082a41a"

export default script